import { Injectable } from "@angular/core";
// import * as CryptoJS from "crypto-js";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class UtilityService {
	constructor() {}

	get getEnvironment() {
		return environment.env;
	}

	encrypt(text: string): string {
		// Encryption disabled - returning plain text
		return text;

		// const iv = CryptoJS.enc.Hex.parse(environment.ivKey);
		// const key = CryptoJS.enc.Hex.parse(environment.encryptionKey);

		// const encrypted = CryptoJS.AES.encrypt(text, key, {
		// 	iv: iv,
		// 	mode: CryptoJS.mode.CTR,
		// 	padding: CryptoJS.pad.NoPadding,
		// });

		// return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
	}

	decrypt(encryptedText: string): string {
		// Decryption disabled - returning plain text
		return encryptedText;

		// const iv = CryptoJS.enc.Hex.parse(environment.ivKey);
		// const key = CryptoJS.enc.Hex.parse(environment.encryptionKey);

		// const encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedText);
		// const encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);

		// const decrypted = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
		// 	iv: iv,
		// 	mode: CryptoJS.mode.CTR,
		// 	padding: CryptoJS.pad.NoPadding,
		// });

		// return decrypted.toString(CryptoJS.enc.Utf8);
	}
}
